import { useQuery } from '@tanstack/react-query';

import { PastStay } from 'src/features/stay/types';
import axios from 'src/lib/axios';
import { ListResponseSmartParkAPI } from 'src/lib/queries';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/visitors/past-stay/`;

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    parkingId: string;
    visitor?: string;
    membership?: string;
    visitor_owner?: string;
    membership_type?: string[];
}
const queryFn = ({ parkingId, ...params }: DTO): Promise<ListResponseSmartParkAPI<PastStay>> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}

const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_PAST_STAYS_RESOURCE, useQueryHook as useListPastStays };
